import { useId } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@quebon/ui/components/button'
import { Spinner } from '@quebon/ui/components/spinner'

interface Props {
  onClick: () => void
  disabled?: boolean
  pending?: boolean
  questionNumber: number
  minimumReached?: boolean
}

export function ReviewNoteExcludeButton({ onClick, disabled = false, pending = false, questionNumber, minimumReached = false }: Props) {
  const { t } = useTranslation('coaching')
  const hintId = useId()
  return (
    <div className="flex flex-col items-end gap-1">
      <Button
        type="button"
        variant="outline"
        size="sm"
        disabled={disabled || pending || minimumReached}
        aria-label={t('reviewNote.excludeQuestion', { no: questionNumber })}
        aria-describedby={minimumReached ? hintId : undefined}
        onClick={onClick}
      >
        {pending ? <Spinner aria-hidden="true" /> : null}
        {t(pending ? 'reviewNote.excluding' : 'reviewNote.exclude')}
      </Button>
      {minimumReached ? <p id={hintId} className="text-xs text-muted-foreground">{t('reviewNote.minimumQuestion')}</p> : null}
    </div>
  )
}
